import { IUserProfileResponse } from './user.interface';
import { IVehicleFromUsers } from './vehicle-from-users.interface';

export interface IUserFromBFF extends IUserProfileResponse {
  userVehicles: IVehicleFromUsers[];
}
